'use client'

import { Suspense } from 'react'
import dynamic from 'next/dynamic'
import { TwitchStreamProps } from './TwitchStream'

// Dynamically import TwitchStream component with no SSR
const TwitchStream = dynamic(() => import('./TwitchStream'), {
  loading: () => <div>Loading...</div>,
  ssr: false, // Disable SSR to avoid hydration issues
})

export function TwitchStreamClientWrapper({ streamData }: { streamData: TwitchStreamProps }) {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <TwitchStream {...streamData} />
    </Suspense>
  )
}
